export default __webpack_public_path__ + "static/media/yeopen_mobile.c45ff5bb.jpg";